import { httpClient } from "./httpClient";

const getAllDivision = () => {
  return httpClient.get("dataDivision");
};

export default {
  getAllDivision,
};
